var logger = {
  baseStyle: "\n    padding: 2px 5px;\n    background-color: #124F5C;\n    border-radius: 4px;\n    color: white; \n  ",
  colors: {
    log: '#124F5C',
    error: '#ed2939',
    warn: '#f39c12'
  },
  log: function log(message, secondary) {
    if (process.env.NODE_ENV == 'development' && this.config.debug) {
      var style = logger.baseStyle + "background-color: ".concat(logger.colors.log);

      if (secondary) {
        console.log('%clocalbase', style, message, secondary);
      } else {
        console.log('%clocalbase', style, message);
      }
    }
  },
  error: function error(message, secondary) {
    if (process.env.NODE_ENV == 'development' && this.config.debug) {
      var style = logger.baseStyle + "background-color: ".concat(logger.colors.error);
      console.error('%clocalbase', style, message);
    }
  },
  warn: function warn(message, secondary) {
    if (process.env.NODE_ENV == 'development' && this.config.debug) {
      var style = logger.baseStyle + "background-color: ".concat(logger.colors.warn);
      console.warn('%clocalbase', style, message);
    }
  }
};
export default logger;